import * as actionTypes from './actionTypes.js';
import { setSelectedTenantIds } from '../internal.js';
import { isDebtor, } from '@debbie/common/dist/permissions/index.js';
import { SITE } from '../config.js';
import { FETCH_ME_SUCCESS } from '../me/actionTypes.js';
const selectedTenantIdReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SELECT_OWNERS: {
            const selectedTenantIds = action.payload.selected
                ? [action.payload.selected]
                : [];
            setSelectedTenantIds(selectedTenantIds);
            return selectedTenantIds;
        }
        case FETCH_ME_SUCCESS: {
            // TODO: Use same auth flow as caseworker and client
            if (SITE === 'debtor') {
                const tenants = action.payload.res.data.tenants;
                const tenant = tenants.filter((t) => isDebtor(t.role))[0];
                if (tenant && state.length === 0) {
                    setSelectedTenantIds([tenant.id]);
                    return [tenant.id];
                }
            }
        }
        default:
            return state;
    }
};
export default selectedTenantIdReducer;
//# sourceMappingURL=reducer.js.map